webpackJsonp([263791100135453],{

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(28));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
	var index = memoize(reactPropsRegex.test.bind(reactPropsRegex));
	
	module.exports = index;


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var PropTypes = _interopDefault(__webpack_require__(2));
	var isPropValid = _interopDefault(__webpack_require__(13));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var channel = '__EMOTION_THEMING__';
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	
	var _contextTypes;
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	var testPickPropsOnStringTag = isPropValid;
	var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	var pickAssign = function pickAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	
	    var _key = void 0;
	
	    for (_key in source) {
	      if (testFn(_key)) {
	        target[_key] = source[_key];
	      }
	    }
	  }
	
	  return target;
	};
	
	function createEmotionStyled(emotion, view) {
	  var _createStyled = function createStyled(tag, options) {
	    if (false) {
	      if (tag === undefined) {
	        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	      }
	    }
	
	    var staticClassName;
	    var identifierName;
	    var stableClassName;
	    var shouldForwardProp;
	
	    if (options !== undefined) {
	      staticClassName = options.e;
	      identifierName = options.label;
	      stableClassName = options.target;
	      shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
	        return tag.__emotion_forwardProp(propName) && // $FlowFixMe
	        options.shouldForwardProp(propName);
	      } : options.shouldForwardProp;
	    }
	
	    var isReal = tag.__emotion_real === tag;
	    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	
	    if (typeof shouldForwardProp !== 'function') {
	      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
	    }
	
	    return function () {
	      var args = arguments;
	      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
	
	      if (identifierName !== undefined) {
	        styles.push("label:" + identifierName + ";");
	      }
	
	      if (staticClassName === undefined) {
	        if (args[0] == null || args[0].raw === undefined) {
	          styles.push.apply(styles, args);
	        } else {
	          styles.push(args[0][0]);
	          var len = args.length;
	          var i = 1;
	
	          for (; i < len; i++) {
	            styles.push(args[i], args[0][i]);
	          }
	        }
	      }
	
	      var Styled =
	      /*#__PURE__*/
	      function (_view$Component) {
	        _inheritsLoose(Styled, _view$Component);
	
	        function Styled() {
	          return _view$Component.apply(this, arguments) || this;
	        }
	
	        var _proto = Styled.prototype;
	
	        _proto.componentWillMount = function componentWillMount() {
	          if (this.context[channel] !== undefined) {
	            this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	          }
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          if (this.unsubscribe !== undefined) {
	            this.context[channel].unsubscribe(this.unsubscribe);
	          }
	        };
	
	        _proto.render = function render() {
	          var props = this.props,
	              state = this.state;
	          this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
	            theme: state !== null && state.theme || props.theme || {}
	          });
	          var className = '';
	          var classInterpolations = [];
	
	          if (props.className) {
	            if (staticClassName === undefined) {
	              className += emotion.getRegisteredStyles(classInterpolations, props.className);
	            } else {
	              className += props.className + " ";
	            }
	          }
	
	          if (staticClassName === undefined) {
	            className += emotion.css.apply(this, styles.concat(classInterpolations));
	          } else {
	            className += staticClassName;
	          }
	
	          if (stableClassName !== undefined) {
	            className += " " + stableClassName;
	          }
	
	          return view.createElement(baseTag, // $FlowFixMe
	          pickAssign(shouldForwardProp, {}, props, {
	            className: className,
	            ref: props.innerRef
	          }));
	        };
	
	        return Styled;
	      }(view.Component);
	
	      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	
	      if (tag.defaultProps !== undefined) {
	        // $FlowFixMe
	        Styled.defaultProps = tag.defaultProps;
	      }
	
	      Styled.contextTypes = contextTypes;
	      Styled.__emotion_styles = styles;
	      Styled.__emotion_base = baseTag;
	      Styled.__emotion_real = Styled;
	      Styled.__emotion_forwardProp = shouldForwardProp;
	      Object.defineProperty(Styled, 'toString', {
	        enumerable: false,
	        value: function value() {
	          if (false) {
	            return 'NO_COMPONENT_SELECTOR';
	          } // $FlowFixMe
	
	
	          return "." + stableClassName;
	        }
	      });
	
	      Styled.withComponent = function (nextTag, nextOptions) {
	        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
	        pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
	      };
	
	      return Styled;
	    };
	  };
	
	  if (false) {
	    _createStyled = new Proxy(_createStyled, {
	      get: function get(target, property) {
	        switch (property) {
	          // react-hot-loader tries to access this stuff
	          case '__proto__':
	          case 'name':
	          case 'prototype':
	          case 'displayName':
	            {
	              return target[property];
	            }
	
	          default:
	            {
	              throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
	            }
	        }
	      }
	    });
	  }
	
	  return _createStyled;
	}
	
	module.exports = createEmotionStyled;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 82:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var emotion = __webpack_require__(7);
	var createEmotionStyled = _interopDefault(__webpack_require__(17));
	
	var index = createEmotionStyled(emotion, React);
	
	Object.keys(emotion).forEach(function (key) { exports[key] = emotion[key]; });
	exports.default = index;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Img = /*#__PURE__*/(0, _reactEmotion2.default)(function (_ref) {
	  var src = _ref.src,
	      alt = _ref.alt,
	      css = _ref.css,
	      ratio = _ref.ratio,
	      width = _ref.width,
	      height = _ref.height,
	      color = _ref.color,
	      props = _objectWithoutProperties(_ref, ['src', 'alt', 'css', 'ratio', 'width', 'height', 'color']);
	
	  return _react2.default.createElement(
	    'div',
	    props,
	    _react2.default.createElement('img', { src: src, alt: alt })
	  );
	}, {
	  target: 'e1rwhw8f0'
	})(function (_ref2) {
	  var _ref2$ratio = _ref2.ratio,
	      ratio = _ref2$ratio === undefined ? 2 / 3 : _ref2$ratio,
	      width = _ref2.width,
	      height = _ref2.height,
	      color = _ref2.color;
	  return {
	    width: width,
	    height: height,
	    position: 'relative',
	    backgroundColor: color,
	
	    '&::after': {
	      content: '""',
	      display: 'block',
	      paddingTop: ratio * 100 + '%'
	    },
	
	    '> img': {
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      objectFit: 'cover'
	    }
	  };
	});
	
	exports.default = Img;
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(7);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(29);
	
	var _styles = __webpack_require__(3);
	
	var _Img = __webpack_require__(54);
	
	var _Img2 = _interopRequireDefault(_Img);
	
	var _portrait = __webpack_require__(303);
	
	var _portrait2 = _interopRequireDefault(_portrait);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  var _css2, _css4, _css6, _css8;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _emotion.css)((_css2 = {}, _css2[_styles.media.tabletMd] = {
	        display: 'flex',
	        alignItems: 'flex-start'
	      }, _css2))
	    },
	    _react2.default.createElement(_Img2.default, {
	      src: _portrait2.default,
	      alt: 'Kasia Marcinkiewicz',
	      ratio: 2599 / 2072,
	      color: '#fde9ea',
	      className: (0, _emotion.css)((_css4 = {
	        width: '100%',
	        '&, img': { borderRadius: 8 }
	      }, _css4[_styles.media.tabletMd] = { width: '40%' }, _css4))
	    }),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)((_css6 = {
	          marginTop: 40
	        }, _css6[_styles.media.tabletMd] = { width: '60%', paddingLeft: 50, marginTop: 0 }, _css6))
	      },
	      _react2.default.createElement(
	        _typography.PageTitle,
	        {
	          className: (0, _emotion.css)((_css8 = {
	            marginBottom: 15
	          }, _css8[_styles.media.tabletMd] = { marginBottom: 20 }, _css8.textAlign = 'left', _css8))
	        },
	        'Hi! My name is Kasia'
	      ),
	      _react2.default.createElement(
	        _typography.Paragraph,
	        null,
	        'I\'m a 24-year-old illustrator from Poland. I admire everything that\'s cute and I try to express it in my art. I love to share joy so I\'d be happy to illustrate (especially children\'s) books or anything related.'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _emotion.css)({
	            marginTop: 20,
	            p: { color: '#ccc', transition: 'color .3s' },
	            ':hover p': { color: '#888' }
	          })
	        },
	        _react2.default.createElement(
	          _typography.Paragraph,
	          null,
	          'Cze\u015B\u0107! Mam na imi\u0119 Kasia i jestem 24-letni\u0105 ilustratork\u0105 z Polski. Uwielbiam wszystko co urocze, co staram si\u0119 wyrazi\u0107 w swojej tw\xF3rczo\u015Bci. Kocham szerzy\u0107 rado\u015B\u0107, wi\u0119c z przyjemno\u015Bci\u0105 zilustruj\u0119 ksi\u0105\u017Cki (zw\u0142aszcza dzieci\u0119ce).'
	        )
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/portrait.078d5aa8.jpg";

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isTouchDevice = exports.isRetina = exports.supportsGrid = exports.supportsHover = exports.max = exports.min = exports.media = exports.breakpoints = exports.rem = exports.em = exports.fancyFont = undefined;
	
	var _reactEmotion = __webpack_require__(4);
	
	(0, _reactEmotion.injectGlobal)({
	  body: {
	    margin: 0,
	    fontFamily: "'Nunito', sans-serif",
	    paddingBottom: 100
	  },
	  a: {
	    textDecoration: 'none',
	    color: 'inherit'
	  },
	  'h1, h2, h3, h4, h5, h6, p, figure': {
	    margin: 0
	  },
	  img: {
	    maxWidth: '100%'
	  }
	});
	
	var fancyFont = exports.fancyFont = {
	  fontWeight: 'normal',
	  fontFamily: "'Amatic SC', sans-serif"
	};
	
	var em = exports.em = function em(val) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
	  return typeof val === 'number' && val !== 0 ? val / base + 'em' : val;
	};
	
	var rem = exports.rem = function rem(val) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
	  return typeof val === 'number' && val !== 0 ? val / base + 'rem' : val;
	};
	
	var breakpoints = exports.breakpoints = {
	  mobile: 1,
	  tablet: 600,
	  laptop: 1024,
	  desktop: 1600,
	
	  mobileSm: 1,
	  mobileMd: 375,
	  mobileLg: 425,
	
	  tabletSm: 600,
	  tabletMd: 768,
	  tabletLg: 900,
	
	  laptopSm: 1024,
	  laptopMd: 1366,
	  laptopLg: 1440,
	
	  desktopSm: 1600,
	  desktopMd: 1700,
	  desktopLg: 1920
	};
	
	var media = exports.media = Object.keys(breakpoints).reduce(function (acc, key) {
	  acc[key] = '@media (min-width: ' + em(breakpoints[key]) + ')';
	  return acc;
	}, {});
	
	var min = exports.min = function min(width) {
	  return '@media (min-width: ' + em(width) + ')';
	};
	
	var max = exports.max = function max(width) {
	  return '@media (max-width: ' + em(width) + ')';
	};
	
	var supportsHover = exports.supportsHover = '@media (hover: hover)';
	
	var supportsGrid = exports.supportsGrid = '@supports(grid-area: auto)';
	
	var isRetina = exports.isRetina = function isRetina() {
	  if (typeof window !== 'undefined') {
	    return window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches;
	  }
	  return false;
	};
	
	var isTouchDevice = exports.isTouchDevice = function isTouchDevice() {
	  if (typeof window !== 'undefined') {
	    return window.matchMedia('(hover: none)').matches;
	  }
	  return false;
	};

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Paragraph = exports.PostDesc = exports.PostTitle = exports.PageTitle = exports.HeaderTitle = exports.NavLink = undefined;
	
	var _extends2, _extends3, _styled;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactEmotion = __webpack_require__(4);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLink = /*#__PURE__*/exports.NavLink = (0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'e119xpzo0'
	})(_extends({
	  position: 'relative',
	  zIndex: 0,
	  fontSize: 30
	}, _styles.fancyFont, (_extends2 = {
	  transitionProperty: 'transform',
	  transitionDuration: '.2s'
	}, _extends2[_styles.supportsHover] = {
	  ':hover:not(.active)': {
	    transform: 'translateY(-1px)'
	  }
	}, _extends2)));
	
	NavLink.Scratch = /*#__PURE__*/(0, _reactEmotion2.default)('svg', {
	  target: 'e119xpzo1'
	})({
	  fill: 'none',
	  position: 'absolute',
	  zIndex: -1,
	  top: 0,
	  left: 0,
	  path: {
	    transition: 'stroke-dashoffset .9s ease-in-out'
	  },
	  '*.active > & > path': {
	    strokeDashoffset: 0
	  }
	});
	
	var HeaderTitle = /*#__PURE__*/exports.HeaderTitle = (0, _reactEmotion2.default)('h1', {
	  target: 'e119xpzo2'
	})(_extends((_extends3 = {
	  fontSize: 48
	}, _extends3[(0, _styles.min)(420)] = { fontSize: 64 }, _extends3), _styles.fancyFont));
	
	var PageTitle = /*#__PURE__*/exports.PageTitle = (0, _reactEmotion2.default)('h1', {
	  target: 'e119xpzo3'
	})({
	  fontWeight: 800,
	  fontSize: 28,
	  textAlign: 'center',
	  opacity: 0.6
	});
	
	var PostTitle = /*#__PURE__*/exports.PostTitle = (0, _reactEmotion2.default)('div', {
	  target: 'e119xpzo4'
	})((_styled = {
	  fontWeight: 800,
	  fontSize: 18,
	  lineHeight: 1.1,
	  textAlign: 'center',
	  opacity: 0.7
	}, _styled[_styles.media.tabletMd] = {
	  fontSize: 36
	}, _styled));
	
	var PostDesc = /*#__PURE__*/exports.PostDesc = (0, _reactEmotion2.default)('p', {
	  target: 'e119xpzo5'
	})({
	  fontWeight: 500,
	  fontSize: 18,
	  textAlign: 'center',
	  opacity: 0.7
	});
	
	var Paragraph = /*#__PURE__*/exports.Paragraph = (0, _reactEmotion2.default)('p', {
	  target: 'e119xpzo6'
	})({
	  fontWeight: 300,
	  fontSize: 18,
	  lineHeight: 1.6,
	  color: '#888'
	});

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-75d1cf10937aa73dbb77.js